module.exports = __webpack_public_path__ + "img/three_dots_icon.0d2f76cf.svg";